@import 'apps/webcomponents/src/assets/fonts.scss';

* {
  box-sizing: border-box;
  font-family: var(--font-family-secondary) !important;
}

:host {
  display: block;
  --search-input-height: 54px;
  --list-max-height: 640px;
  --sublist-max-height: 640px;
  --list-max-width: 240px;
  --list-lateral-offset: 4px;
}

.list-unstyled {
  list-style: none;
  margin: 0;
  padding: 0;
}

.list {
  color: var(--main-titles-inputs-600);
  background-color: var(--white-layout-301-level-0-elevation);
  width: var(--list-max-width);
  max-height: calc(var(--list-max-height) / 2);
  overflow-y: auto;
  scrollbar-width: thin;
}

.sub-list {
  background-color: var(--white-layout-301-level-0-elevation);
  box-shadow: 2px 2px 10px 0px var(--grey-layout-201-disabled-text);
  border-radius: calc(var(--spacer) / 2);
  max-height: calc(var(--sublist-max-height) / 2);
  overflow-y: auto;
  scrollbar-width: thin;
}

.sub-list-wrapper {
  width: calc(var(--list-max-width) + var(--list-lateral-offset));
  max-height: var(--sublist-max-height);
  display: none;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  padding: 0 var(--list-lateral-offset);
}

.list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: solid 1px transparent;
  padding: var(--spacer) calc(2 * var(--spacer));
  line-height: 18px;
  height: calc(4 * var(--spacer));
  cursor: pointer;
  position: relative;
  color: var(--main-titles-inputs-600);

  .tooltip {
    flex: 1;
  }

  &.has-divider {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }

  .list-icon {
    transform: translateX(var(--spacer));
  }

  span {
    font-size: var(--body-size-large);
    line-height: 1;
  }

  &[disabled] {
    pointer-events: none;
    cursor: default;
    color: var(--grey-layout-200-disabled);
  }

  &:not([disabled]):hover {
    background-color: var(--chart-051-hover);
  }

  &:focus-visible {
    border-color: var(--blue-layout-500-focus);
    background-color: var(--focus-bg-color);
    outline: none;
  }

  &:not([disabled]):active {
    background-color: var(--chart-100-pressed);
  }
}

.has-search {
  .list-item:not(.sub-list-wrapper .list-item):first-of-type {
    margin-top: var(--search-input-height);
  }
}

.search-wrapper {
  padding: 12px 16px;
  position: absolute;
  background: var(--white-layout-301-level-0-elevation);
  z-index: 999;
  width: var(--list-max-width);
}

.no-results {
  margin-top: var(--search-input-height);
  text-align: center;
  padding: calc(var(--spacer) * 3) 0;
  display: none;
  background-color: var(--white-layout-301-level-0-elevation);
  font-size: var(--body-size-large);

  &.visible {
    display: block;
    color: var(--main-titles-inputs-600);
    background: transparent;
  }
}

:host([hasSearch]) {
  --list-max-height: 748px;
}
